import React from 'react';
import Icon from '../../Common/Icon';

const LIFE_CATEGORIES = [
  {
    icon: 'sun',
    title: 'Routines',
    image: '/landing/domain-routines.jpg',
    alt: 'Person stretching in bed near a bright window',
    focus: 'Morning starts, evening resets, and small consistency loops.',
    example: 'Test a 30-minute screen-free wind-down and track morning energy.'
  },
  {
    icon: 'zap',
    title: 'Energy',
    image: '/landing/domain-energy.jpg',
    alt: 'Person breathing calmly outside in warm light',
    focus: 'Notice what drains, restores, or steadies you.',
    example: 'Compare a walk before work with your usual first hour.'
  },
  {
    icon: 'briefcase',
    title: 'Work',
    image: '/landing/domain-work.jpg',
    alt: 'Black professional woman working calmly at a laptop',
    focus: 'Focus, productivity, purpose.',
    example: 'Test one deep-work block before messages for five days.'
  },
  {
    icon: 'heart',
    title: 'Relationships',
    image: '/landing/domain-relationships.jpg',
    alt: 'Couple sitting together in a warm home',
    focus: 'Connection, communication, repair.',
    example: 'Test asking one clarifying question before reacting.'
  },
  {
    icon: 'lightbulb',
    title: 'Creativity',
    image: '/landing/domain-creativity.jpg',
    alt: 'Person writing in a notebook near plants',
    focus: 'Ideas, expression, flow.',
    example: 'Test a 10-minute ugly first draft before consuming content.'
  },
  {
    icon: 'book-open',
    title: 'Learning',
    image: '/landing/domain-learning.jpg',
    alt: 'Person reading on a tablet with headphones by a window',
    focus: 'Growth, curiosity, skills.',
    example: 'Test a 15-minute skill sprint after breakfast for 10 days.'
  }
];

const LandingLifeCategories = React.memo(() => (
  <section id="examples" className="landing-life-section">
    <div className="landing-template-frame landing-life-frame">
      <header className="landing-section-header landing-section-header--center">
        <h2>One loop, many life domains</h2>
        <p className="landing-sr-only">
          One loop for the parts of life you are trying to change.
        </p>
      </header>

      <div className="landing-domain-gallery">
        {LIFE_CATEGORIES.map((category) => (
          <article key={category.title} className="landing-domain-card">
            <img src={category.image} alt={category.alt} loading="lazy" />
            <div className="landing-domain-label">
              <span>
                <Icon name={category.icon} size={20} />
              </span>
              <h3>{category.title}</h3>
            </div>
            <p className="landing-sr-only">
              {category.focus} {category.example}
            </p>
          </article>
        ))}
      </div>
    </div>
  </section>
));

LandingLifeCategories.displayName = 'LandingLifeCategories';

export default LandingLifeCategories;
